import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CxMaterialConfigProviders } from '@bbraun/cortex';
import { CxDialogModule } from '@bbraun/cortex/dialog';
import { CxFloatingButtonModule } from '@bbraun/cortex/floating-button';
import { CxSnackbarModule, SNACKBAR_CONFIG } from '@bbraun/cortex/snackbar';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { AuthModule } from './modules/auth/auth.module';
import { SplashScreenModule } from './modules/shared/components/splash-screen/splash-screen.module';
import { NOTIFICATION_DURATION_IN_MS } from './modules/shared/constants/notification/notification.constants';
import { HttpErrorInterceptor } from './modules/shared/interceptors/https.interceptor';
import { ManageHttpInterceptor } from './modules/shared/interceptors/manage-http.interceptor';
import { TranslocoRootModule } from './modules/transloco-root/transloco-root.module';
import { effects, reducers } from './store/app-state';

@NgModule({ declarations: [
  AppComponent
],
bootstrap: [AppComponent], imports: [BrowserModule,
  AppRoutingModule,
  BrowserAnimationsModule,
  StoreModule.forRoot(reducers),
  EffectsModule.forRoot(effects),
  AuthModule.forRoot(),
  CxDialogModule,
  CxSnackbarModule,
  CxFloatingButtonModule,
  MatDialogModule,
  SplashScreenModule,
  TranslocoRootModule,
  StoreDevtoolsModule.instrument({
    maxAge: 25, // Retains last 25 states
    logOnly: environment.production
  })], providers: [
  CxMaterialConfigProviders,
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill', floatLabel: 'auto' } },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ManageHttpInterceptor,
    multi: true
  },
  {
    provide: SNACKBAR_CONFIG,
    useValue: { timeout: NOTIFICATION_DURATION_IN_MS }
  },
  provideHttpClient(withInterceptorsFromDi())
] })
export class AppModule {
}

